const $ = jQuery.noConflict();

class Tables {
	constructor() {
		this.tables = $('table.tablepress');
	}

	init() {
		this.toggleShadow();

		this.tables.each((i, el) => {
			const headings = el.querySelectorAll('thead th');

			if (headings.length) {
				headings.forEach((heading) => {
					if (heading.className) {
						const columns = el.querySelectorAll(
							'td.' + heading.className
						);

						if (columns.length) {
							columns.forEach((column) => {
								const label = document.createElement('div');
								const text = document.createTextNode(
									heading.innerText
								);
								label.classList.add('table-mobile-label');

								label.appendChild(text);
								column.insertBefore(label, column.firstChild);
							});
						}
					}
				});
			}
		});
	}

	toggleShadow() {
		this.tables.each((i, el) => {
			const item = $(el);
			const scrollWrapper = item.closest('.tablepress-scroll-wrapper');

			scrollWrapper.removeClass('has-scroll');
			if (item[0].offsetWidth > scrollWrapper.width()) {
				scrollWrapper.addClass('has-scroll');
			}
		});
	}
}

export default new Tables();
